module.exports = __webpack_public_path__ + "static/media/play-resign.06f42c1d.mp3";